/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/382-share': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4 10s.919-3 6-3v3l6-4-6-4v3c-4 0-6 2.495-6 5zm7 2H2V6h1.967c.158-.186.327-.365.508-.534A6.933 6.933 0 016.914 4H0v10h13V9.803l-2 1.333V12z"/>'
  }
})
